import React from "react";
import values from "lodash/values";
import pick from "lodash/pickBy";
import moment from "moment";
import { Link } from "react-router";
import { RaisedButton } from "material-ui";
import { Table, Tr, Td, Sort } from "reactable";
import { colors } from "material-ui/styles";

import connectToStores from "alt-utils/lib/connectToStores";
import ExternalSyncActions from "../actions/ExternalSyncActions";
import ExternalSyncStore from "../stores/ExternalSyncStore";

import WorkingIndicator from "./partials/working-indicator.jsx";

class ExternalSyncs extends React.Component {
  constructor(props) {
    super(props);
    this._makeRowForExternalSync = this._makeRowForExternalSync.bind(this);
  }

  static getStores() {
    return [ExternalSyncStore];
  }

  static getPropsFromStores() {
    return {
      externalSyncs: ExternalSyncStore.getState().externalSyncs
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  _makeRowForExternalSync(externalSync) {
    return (
      <Tr>
        <Td column="Label" value={externalSync.label} style={{ maxWidth: 300 }}>
          {externalSync.label}
        </Td>
        <Td
          column="Description"
          value={externalSync.description}
          style={{ maxWidth: 300 }}
        >
          {externalSync.description}
        </Td>
        <Td column="Last Synced" value={externalSync.last_synced_at}>
          {externalSync.last_synced_at
            ? `${moment(externalSync.last_synced_at).format("lll")}`
            : "Waiting for first sync"}
        </Td>
        <Td column="Last Sync Details">
          {externalSync.last_sync_details.error_message ? (
            <span style={{ color: colors.red600 }}>
              Failed: {externalSync.last_sync_details.error_message}
            </span>
          ) : externalSync.last_sync_details.message ? (
            <span style={{ color: "#4CAF50" }}>
              {externalSync.last_sync_details.message}
            </span>
          ) : (
            "—"
          )}
        </Td>
        <Td column="Actions">
          <div>
            <Link
              to={`/event_buckets/${this.props.params.eventBucketId}/external_syncs/${externalSync.id}`}
            >
              Manage sync
            </Link>
          </div>
        </Td>
      </Tr>
    );
  }

  componentWillMount() {
    ExternalSyncActions.fetchAllForBucket(this.props.params.eventBucketId);
  }

  render() {
    let styles = this.getStyles(),
      bucket = this.props.params.eventBucketId,
      externalSyncs = values(
        pick(this.props.externalSyncs, e => e.event_bucket === bucket)
      ),
      rows = externalSyncs.map(this._makeRowForExternalSync);

    if (externalSyncs.length === 0 && ExternalSyncStore.getState().isFetching) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <h1 className="page-title">External Syncs</h1>
        <Table
          className="bordered striped responsive-table"
          sortable={[
            { column: "Label", sortFunction: Sort.CaseInsensitive },
            { column: "Description", sortFunction: Sort.CaseInsensitive },
            "Last Synced",
            "Last Sync Details"
          ]}
          defaultSort={{ column: "Description", direction: "asc" }}
          columns={[
            "Label",
            "Description",
            "Last Synced",
            "Last Sync Details",
            "Actions"
          ]}
          filterable={["Description", "Label"]}
          filterPlaceholder="Type to filter..."
        >
          {rows}
        </Table>
        {rows.length === 0 ? (
          <div className="empty-table-message">
            No external syncs yet.{" "}
            <Link to={`/event_buckets/${bucket}/external_syncs/new`}>
              Create a new external sync.
            </Link>
          </div>
        ) : null}
        <div style={{ marginTop: 20 }}>
          <RaisedButton
            label="Create new external sync"
            primary={true}
            onTouchTap={() =>
              this.context.router.push(
                `/event_buckets/${this.props.params.eventBucketId}/external_syncs/new`
              )
            }
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(ExternalSyncs);



// WEBPACK FOOTER //
// ./src/app/components/external-syncs.jsx